(() => {
  if (customElements.get('loxhaven-review-gallery')) return;

  class LoxhavenReviewGallery extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.addEventListener('click', (event) => this.openPhoto(event), { signal: this.events.signal });
    }

    disconnectedCallback() {
      this.events?.abort();
      this.events = null;
      this.dialog?.remove();
      this.dialog = null;
      this.opener = null;
    }

    createDialog() {
      const dialog = document.createElement('dialog');
      dialog.className = 'lhx-review-dialog';
      dialog.setAttribute('aria-label', 'Customer review photo');
      dialog.innerHTML = `
        <div class="lhx-review-dialog__header">
          <h2 class="lhx-review-dialog__title"></h2>
          <button type="button" class="lhx-review-dialog__close" aria-label="Close customer review photo" autofocus><span aria-hidden="true">×</span></button>
        </div>
        <img class="lhx-review-dialog__image" alt="">
        <p class="lhx-review-dialog__caption"></p>`;
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      // Native dialog supplies focus trapping and Escape; return focus explicitly
      // so closing through the button or backdrop has the same keyboard behavior.
      dialog.addEventListener('close', () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        this.opener = null;
      });
      const outside = (event) => {
        const box = dialog.getBoundingClientRect();
        return event.target === dialog &&
          (event.clientX < box.left || event.clientX > box.right ||
           event.clientY < box.top || event.clientY > box.bottom);
      };
      let backdropPress = false;
      dialog.addEventListener('pointerdown', (event) => { backdropPress = outside(event); });
      dialog.addEventListener('click', (event) => {
        if (backdropPress && outside(event)) dialog.close();
        backdropPress = false;
      });
      this.append(dialog);
      this.dialog = dialog;
      return dialog;
    }

    openPhoto(event) {
      const link = event.target.closest?.('a.loox-review-media-link');
      if (!link || !this.contains(link) || event.defaultPrevented ||
          event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!window.HTMLDialogElement || !HTMLDialogElement.prototype.showModal) return;
      const image = link.querySelector('img');
      const review = link.closest('.loox-review');
      if (!image || !review) return;
      event.preventDefault();
      const dialog = this.dialog || this.createDialog();
      const reviewer = review.querySelector('.loox-reviewer-name')?.textContent.trim();
      const title = reviewer ? `Customer photo — ${reviewer}` : 'Customer review photo';
      dialog.setAttribute('aria-label', title);
      dialog.querySelector('.lhx-review-dialog__title').textContent = title;
      dialog.querySelector('.lhx-review-dialog__caption').textContent =
        review.querySelector('.loox-review-body')?.textContent.trim() || '';
      const enlarged = dialog.querySelector('img');
      enlarged.src = link.href;
      enlarged.alt = image.alt || 'Customer review photo';
      this.opener = link;
      dialog.showModal();
      dialog.querySelector('button').focus({ preventScroll: true });
    }
  }

  customElements.define('loxhaven-review-gallery', LoxhavenReviewGallery);
})();
